import { UserRoles } from '@centric-os/types';

const ROLE_ACTION_SUFFIX = '_role';

const ValidUserRoles: ReadonlySet<string> = new Set(Object.values(UserRoles));

/**
 * Returns whether a role scope or form role value maps to a supported `UserRoles` enum entry.
 * Accepts a role action (e.g. `site_operator_role`) or a full scope (e.g. `site_operator_role:group:123`).
 */
export function isValidUserRoleScope(roleScope: string | null | undefined): boolean {
  if (!roleScope) return false;

  const action = roleScope.split(':')[0];
  if (!action.endsWith(ROLE_ACTION_SUFFIX)) return false;

  const role = action.slice(0, -ROLE_ACTION_SUFFIX.length);
  return ValidUserRoles.has(role);
}
